import { useState, useEffect, useCallback } from 'react';
import mondayApi from '../services/mondayApiStandalone';

export const useAssets = (assetIds) => {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAssets = useCallback(async (ids) => {
    if (!ids || ids.length === 0) {
      setAssets([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await mondayApi.getAssets(ids);
      setAssets(response.assets || []);
    } catch (err) {
      console.error('Error fetching assets:', err);
      setError(err);
      setAssets([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (assetIds && assetIds.length > 0) {
      fetchAssets(assetIds);
    } else {
      setAssets([]);
    }
  }, [assetIds, fetchAssets]);

  return {
    assets,
    loading,
    error,
    refetch: () => fetchAssets(assetIds)
  };
};

// Helper function to extract asset IDs from file objects
export const extractAssetIds = (files) => {
  if (!files || !Array.isArray(files)) {
    return [];
  }

  return files
    .map(file => {
      // Try different possible asset ID field names
      return file.assetId || file.asset_id || file.id;
    })
    .filter(Boolean); // Remove null/undefined values
};